/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback } from 'react'

import './mainAdm.css'
import 'react-toastify/dist/ReactToastify.css'

import { Outlet, useNavigate, useLocation } from 'react-router-dom'

import Header from '../header/header'
import Menu from './menuAdm/menuAdm'
import Logo from '../../assets/SBF-Logo-1.png'

import useAuth from '../../hooks/useAuthContext'
import useApp from '../../hooks/useAppContext'
import useNotificacoesPolling from '../../hooks/useNotificacoesPolling'
import { CadastroProvider } from '../../contexts/CadastroContext'

const MainAdm = () => {
  const navigate = useNavigate()
  const { validarUser, isAppLoaded, setIsAppLoaded, usuario } = useAuth()
  const { consultarNotificacoes } = useApp()
  const location = useLocation()

  useNotificacoesPolling({
    enabled: Boolean(usuario?.tipo && usuario.tipo !== 'recepcao'),
    consultarNotificacoes,
  })

  const fetchProfile = async () => {
    try {
      let validacao = await validarUser()

      if (validacao?.acessoBloqueado) {
        navigate('/acesso-em-breve')
        return
      }

      if (validacao?.tipo === 'recepcao') {
        if (!location.pathname.includes('/private/adm/recepcao') && !location.pathname.includes('/private/adm/m_m')) {
          navigate('/private/adm/recepcao')
        }
      }

      if (validacao?.tipo === 'convidado' && validacao?.tipo === 'patrocinador') {
        navigate('/private')
      }
      if (location.pathname.includes('/private/adm')) {
        if (
          validacao?.tipo !== 'administracao' &&
          validacao?.tipo !== 'administracao_dash' &&
          validacao?.tipo !== 'recepcao'
        ) {
          navigate('/private')
        }
      }

      setIsAppLoaded(true)
    } catch (error) { }
  }

  useEffect(() => {
    fetchProfile()
  }, [])

  const getAppTemplate = useCallback(() => {
    if (!isAppLoaded) {
      return (
        <div className="loading">
          <img
            src={Logo}
            alt="SBF"
            width={'50%'}
          />
        </div>
      )
    }
    return (
      <div className="wrapper">
        <CadastroProvider>
          <Header />
          <Menu />
          <main className="adm-scroll-area">
            <Outlet />
          </main>
        </CadastroProvider>
      </div>
    )
  }, [isAppLoaded, location])

  return getAppTemplate()
}

export default MainAdm
